import { render, staticRenderFns } from "./reportDetail.vue?vue&type=template&id=1fbea501&scoped=true&"
import script from "./reportDetail.vue?vue&type=script&lang=js&"
export * from "./reportDetail.vue?vue&type=script&lang=js&"
import style0 from "./reportDetail.vue?vue&type=style&index=0&id=1fbea501&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbea501",
  null
  
)

export default component.exports